import React from 'react';

import { Heading, Portfolio } from '../../../components';



const PortfolioSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Portfolio'} subTitle={'Our Past Events'} />

      {/* Portfolio Component */}
      <Portfolio />

    </section>

  );
}

export default PortfolioSection;